/**
 * @file shop-context.ts
 *
 * Shop context and `useShop` hook. Once {@link ./ShopGate} has resolved the
 * session's shop (get-or-create), it provides the shop here so the admin subtree
 * can read it without refetching. The provider lives in {@link ./ShopGate}.
 */

import { createContext, useContext } from 'react';
import type { Shop } from '../api/shop';

export const ShopContext = createContext<Shop | undefined>(undefined);

/**
 * Reads the current session's shop.
 *
 * @returns The resolved {@link Shop}.
 *
 * @throws {Error} When used outside a resolved {@link ./ShopGate}.
 */
export function useShop(): Shop {
  const shop = useContext(ShopContext);
  if (!shop) {
    throw new Error('useShop must be used within a resolved ShopGate');
  }
  return shop;
}
